import { GlobalState } from './Global.interface';

type GlobalAction = { type: 'setLoggedIn' | 'setLoading' | 'setCurrentFcStore' | 'setParamsNavigator'; payload: any };

export const globalReducer = (state: GlobalState, action: GlobalAction): GlobalState => {
    switch (action.type) {
        case 'setLoggedIn':
            return {
                ...state,
                isLoggedIn: action.payload,
            };
        case 'setLoading':
            return {
                ...state,
                isLoading: action.payload,
            };

        case 'setCurrentFcStore':
            return {
                ...state,
                currentFcStore: action.payload,
            };

        case 'setParamsNavigator':
            return {
                ...state,
                paramsNavigator: action.payload,
            };
        default:
            return state;
    }
};
